import { ICardName } from '../types/kato.types';

export const leftMenuItems = [
  {
    key: 'indicators',
    link: 'indicators',
  },
  {
    key: 'projects',
    link: 'projects',
  },
  {
    key: 'geoportal',
    link: 'geoportal',
  },
];

export const iframeOptions: Record<string, { title: string; link: string }> = {
  [ICardName.INFRASTRUCTURE]: {
    title: 'Инфраструктура',
    link: 'https://app.powerbi.com/view?r=eyJrIjoiZTRiMzgzMWMtNTE5ZS00YWNmLWIwY2YtNDE5ZWFmZjQxYzhmIiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9',
  },
  'finance-aid': {
    title: 'Финансовая помощь',
    link: 'https://app.powerbi.com/view?r=eyJrIjoiMDI4YjIxOTctOTgzMy00ZGFmLTg2NGItYmFmMDk3MmFiYWJjIiwidCI6ImU2MjQzNTFhLWViZGItNDUwMi1hNGEzLTRiZWI3OTYxODBlZiIsImMiOjl9',
  },
  geoportal: {
    title: 'Геопортал',
    link: 'https://map.iaqmola.kz/',
  },
};

export const sections: string[] = [
  'kato-list',
  // 'analytics',
  // 'sections',
];

export const adminTabs: string[] = [
  'general-info',
  'road',
  'self-sufficiency',
  'ser',
  'infrastructure',
  'population-dynamic',
  'budget-investment-projects',
  'tax',
  // 'budget',
  'screening',
  // 'population-demand',
  // 'agricultural_producers',
  // 'village_improvement',
  // 'investments',
  // 'additional_info',
  // "infrastructure-projects",
  // 'SNP_INVESTMENT',
  // 'SNP_IMPROVEMENT'
];
